<script lang="ts">
  import Field from "$lib/components/Field.svelte";
  import Button from "$lib/components/Button.svelte";
  import Banner from "$lib/components/Banner.svelte";
  import { loginWithDevPassword } from "$lib/api/endpoints";
  import { AppError } from "$lib/api/problem";
  import { safeReturnPath } from "$lib/auth/returnTo";
  import { session } from "$lib/stores/session.svelte";
  import { router } from "../../router.svelte";

  let { email = $bindable(""), returnTo = "/" }: { email?: string; returnTo?: string } = $props();
  let password = $state("");
  let busy = $state(false);
  let error = $state<AppError | null>(null);

  async function signIn(event: SubmitEvent): Promise<void> {
    event.preventDefault();
    if (busy || !email.trim() || !password) return;
    busy = true;
    error = null;
    try {
      await loginWithDevPassword(email.trim(), password);
      password = "";
      await session.refresh();
      router.navigate(safeReturnPath(returnTo), { replace: true });
    } catch (err) {
      if (err instanceof AppError) error = err;
    } finally {
      password = "";
      busy = false;
    }
  }
</script>

<form class="stack dev-password" onsubmit={signIn}>
  <p class="label">Development instance</p>
  {#if error}
    <Banner tone="error" title="Couldn't sign in" correlationId={error.correlationId}>{error.userMessage}</Banner>
  {/if}
  <Field id="dev-login-email" label="Account email" type="email" bind:value={email} autocomplete="username" required />
  <Field id="dev-login-password" label="Password" type="password" bind:value={password} autocomplete="current-password" required />
  <Button type="submit" fullWidth loading={busy}>Sign in with password</Button>
  <p class="note">Password sign-in is available only in development.</p>
</form>

<style>
  .dev-password { border-top: 1px solid var(--line-soft); margin-top: 20px; padding-top: 20px; }
  .label { margin: 0; font-size: 14px; font-weight: 600; }
  .note { margin: 0; color: var(--muted); font-size: 13px; }
</style>
